<template>
  <v-dialog max-width="800" @click:outside="closeModal">
    <v-card class="h-auto bg-white font-inter" :loading="loading">
      <div class="pt-3 bg-slate-100">
        <div class="flex justify-between items-center pb-2 px-3">
          <h4 class="font-bold text-lg">Generate File Keabsahan</h4>
          <div class="flex gap-3 items-center">
            <v-btn
              variant="outlined"
              class="capitalize text-xs w-28 opacity-80 border-gray-400"
              @click="previewFile()"
            >
              <template #prepend>
                <img
                  src="../../../assets/icon/eye.png"
                  alt="Download Icon"
                  class="h-4 w-auto"
                />
              </template>
              <span class="font-medium"> Preview </span>
            </v-btn>
            <v-btn
              variant="outlined"
              class="capitalize text-xs w-28 cursor-pointer opacity-80 border-gray-400"
              @click="generateFile()"
            >
              <template #prepend>
                <img
                  src="../../../assets/icon/download.png"
                  alt="Download Icon"
                  class="h-4 w-auto"
                />
              </template>
              <span class="font-medium"> Download </span>
            </v-btn>

            <v-btn
              variant="outlined"
              class="capitalize text-xs w-28 border-gray-400 bg-slate-100"
              @click="closeModal"
            >
              <span class="text-gray-500"> Close </span>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="rounded-md mx-3 my-3 !bg-white">
        <v-form ref="form" class="grid grid-cols-2 gap-2">
          <div class="col-span-2 mt-4 relative">
            <hr class="border-t-2 border-dashed border-gray-400" />
            <span
              class="absolute -top-2 bg-white pr-2 text-xs text-gray-600 transform font-semibold"
            >
              Data Personil
            </span>
          </div>
          <div>
            <label
              for="name_validity"
              class="text-xs text-gray-600 font-semibold"
            >
              Nama
            </label>
            <v-text-field
              id="name_validity"
              variant="outlined"
              color="#475569"
              density="compact"
              hide-details="auto"
              placeholder="Nama lengkap..."
              :rules="formValidasi.name"
              v-model="formValue.name"
            >
            </v-text-field>
          </div>
          <div>
            <label
              for="nik_validity"
              class="text-xs text-gray-600 font-semibold"
            >
              NIK
            </label>
            <v-text-field
              id="nik_validity"
              variant="outlined"
              color="#475569"
              density="compact"
              hide-details="auto"
              v-model="formValue.nik"
              placeholder="Masukkan NIK"
              :rules="formValidasi.nik"
            >
            </v-text-field>
          </div>
          <div>
            <label
              for="jabatan_validity"
              class="text-xs text-gray-600 font-semibold"
            >
              Jabatan
            </label>
            <v-text-field
              id="jabatan_validity"
              variant="outlined"
              color="#475569"
              density="compact"
              hide-details="auto"
              placeholder="Masukkan Jabatan"
              :rules="formValidasi.position"
              v-model="formValue.position"
            >
            </v-text-field>
          </div>
          <div>
            <label
              for="ttd_validity"
              class="text-xs text-gray-600 font-semibold"
            >
              Tanda Tangan (PNG/JPG)
            </label>
            <v-file-input
              id="ttd_validity"
              prepend-icon=""
              prepend-inner-icon="mdi-upload"
              accept=".png, .jpeg, .jpg"
              variant="outlined"
              color="#475569"
              density="compact"
              placeholder="Masukkan Tanda Tangan"
              hide-details="auto"
              show-size
              :rules="formValidasi.ttd"
              v-model="fileTtd"
              @change="handleFileChange('ttd')"
            ></v-file-input>
          </div>
          <div class="col-span-2">
            <label
              for="address_validity"
              class="text-xs text-gray-600 font-semibold"
            >
              Alamat
            </label>
            <v-textarea
              id="address_validity"
              color="#475569"
              variant="outlined"
              density="compact"
              auto-grow
              rows="2"
              placeholder="Masukkan Alamat"
              hide-details="auto"
              :rules="formValidasi.address"
              v-model="formValue.address"
            ></v-textarea>
          </div>
          <div class="col-span-2 mt-4 relative">
            <hr class="border-t-2 border-dashed border-gray-400" />
            <span
              class="absolute -top-2 bg-white pr-2 text-xs text-gray-600 transform font-semibold"
            >
              Penanggung Jawab Operasional
            </span>
          </div>
          <div>
            <label for="pjo" class="text-xs text-gray-600 font-semibold">
              Nama
            </label>
            <v-text-field
              id="pjo"
              variant="outlined"
              color="#475569"
              density="compact"
              hide-details="auto"
              placeholder="Masukkan Penanggung Jawab Operasional"
              :rules="pjo.name ? [] : formValidasi.name_pjo"
              v-model="formValue.name_pjo"
              v-if="!pjo.name"
            >
            </v-text-field>
            <h5 class="text-sm font-semibold text-gray-700" v-else>
              {{ formValue.name_pjo }}
            </h5>
          </div>
          <div>
            <label
              for="ttd_validity"
              class="text-xs text-gray-600 font-semibold"
            >
              Tanda Tangan (PNG/JPG)
            </label>
            <v-file-input
              id="ttd_validity"
              prepend-icon=""
              prepend-inner-icon="mdi-upload"
              accept=".png, .jpeg, .jpg"
              variant="outlined"
              color="#475569"
              density="compact"
              placeholder="Masukkan Tanda Tangan"
              hide-details="auto"
              show-size
              :rules="pjo.ttd ? [] : formValidasi.ttd"
              v-model="fileTtdPjo"
              @change="handleFileChange('ttd_pjo')"
              v-if="!pjo.ttd"
            ></v-file-input>
            <img
              v-else
              :src="previewTtdPjo"
              alt="ttd-pjo"
              class="h-8 w-auto mix-blend-multiply"
            />
          </div>
        </v-form>
      </div>
    </v-card>
    <PreviewModal
      v-model="dialogPreview"
      :preview-url="previewUrl"
      @close-modal="closeModalSecond"
    />
  </v-dialog>
</template>

<script>
import util from "@/assets/js/util";
import {
  FormGenerateFileValidity,
  FormValidasiDataValidity,
} from "../core/FormData";
import { cloneDeep } from "lodash";
import axios from "axios";
import { API_BASE_URL, APP_BACKEND_ESG, CMS_VIEW_IMAGE } from "@/constants";
import PreviewModal from "./PreviewModal.vue";
import moment from "moment";

const base_url = APP_BACKEND_ESG;

export default {
  name: "GenerateFileValidityModal",
  components: {
    PreviewModal,
  },
  data() {
    return {
      formValidasi: FormValidasiDataValidity,
      formValue: cloneDeep(FormGenerateFileValidity),
      fileTtd: null,
      fileTtdPjo: null,
      dialogPreview: false,
      previewUrl: null,
      loading: false,
      previewTtdPjo: null,
    };
  },
  props: {
    pjo: Object,
    idContractor: Number,
    dialog: Boolean,
    contractorName: String,
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.pjo.ttd) {
        this.previewTtdPjo = API_BASE_URL + CMS_VIEW_IMAGE + this.pjo.ttd;
        this.formValue.ttd_pjo = this.pjo.ttd;
      }
      if (newVal && this.pjo.name) {
        this.formValue.name_pjo = this.pjo.name;
      }
    },
  },
  methods: {
    generateFile() {
      this.fileFalidity(false);
    },
    previewFile() {
      this.fileFalidity(true);
    },
    async fileFalidity(preview) {
      const formData = await this.$refs.form.validate();
      if (formData.valid) {
        this.setLoading(true);
        try {
          const monthNumber = parseInt(this.$route.params.id_month);
          const month = moment()
            .locale("id")
            .month(monthNumber - 1)
            .format("MMMM");

          const year = this.$route.params.year;
          const area = this.$route.params.workArea;

          const bodyJson = {
            name: this.formValue.name,
            name_pjo: this.formValue.name_pjo,
            nik: this.formValue.nik,
            position: this.formValue.position,
            personal_address: this.formValue.address,
            id_contractor: this.idContractor,
            ttd: this.formValue.ttd,
            ttd_pjo: this.formValue.ttd_pjo,
            area,
            month,
            year,
          };

          const response = await axios.post(
            `${base_url}/generate-pdf/file-validity`,
            bodyJson,
            {
              responseType: "blob",
            }
          );

          const blob = new Blob([response.data], { type: "application/pdf" });

          if (preview) {
            this.previewUrl = window.URL.createObjectURL(blob);
            this.dialogPreview = true;
          } else {
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            let fileName =
              "File keabsahan_" +
              area +
              "_" +
              month +
              "_" +
              year +
              "_" +
              this.contractorName +
              ".pdf";
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(url);
          }
        } catch (err) {
          this.setLoading(false);
          util.showError(err);
        } finally {
          setTimeout(() => {
            this.setLoading(false);
          }, 1000);
        }
      }
    },
    closeModalSecond() {
      this.dialogPreview = false;
      this.previewUrl = null;
    },
    closeModal() {
      this.formValue = cloneDeep(FormGenerateFileValidity);
      this.fileTtd = null;
      this.fileTtdPjo = null;
      this.dialogPreview = false;
      this.previewUrl = null;
      this.$emit("close-modal");
    },
    async handleFileChange(field) {
      let file = null;

      if (field === "ttd" && this.fileTtd) file = this.fileTtd;
      if (field === "ttd_pjo" && this.fileTtdPjo) file = this.fileTtdPjo;

      if (!file) return;

      const resizedBase64 = await this.resizeImageToBase64(file, 150, 0.8);
      this.formValue[field] = resizedBase64;
    },
    async resizeImageToBase64(file, targetHeight = 100, quality = 0.4) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const img = new Image();

        reader.onload = (e) => {
          img.src = e.target.result;
        };

        img.onload = () => {
          const aspectRatio = img.width / img.height;
          const targetWidth = targetHeight * aspectRatio;

          const canvas = document.createElement("canvas");
          canvas.width = targetWidth;
          canvas.height = targetHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

          // ubah ke JPEG supaya ukuran lebih kecil
          const base64String = canvas.toDataURL("image/jpeg", quality);
          resolve(base64String);
        };

        img.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
      });
    },
    setLoading(status) {
      this.loading = status;
    },
  },
};
</script>
